import * as React from 'react';
const SvgExternalLink = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.542 4.519v4.023a.75.75 0 0 0 1.5 0V2.708a.75.75 0 0 0-.75-.75h-5.834a.75.75 0 0 0 0 1.5h4.023l-6.22 6.22a.75.75 0 0 0 1.06 1.06z"
    />
    <path
      fill="currentColor"
      d="M5.209 4.708a1.75 1.75 0 0 0-1.75 1.75v8.334c0 .966.783 1.75 1.75 1.75h8.333a1.75 1.75 0 0 0 1.75-1.75v-4.167a.75.75 0 0 1 1.5 0v4.167a3.25 3.25 0 0 1-3.25 3.25H5.209a3.25 3.25 0 0 1-3.25-3.25V6.458a3.25 3.25 0 0 1 3.25-3.25h4.166a.75.75 0 1 1 0 1.5z"
    />
  </svg>
);
export default SvgExternalLink;
